document.addEventListener("DOMContentLoaded", function () {
console.log("script loaded");
const slides = document.querySelectorAll(".slider-block");
const slideWrap = document.querySelector(".slide-content");
const slideCount = slides.length;
const slideWidth = slides[0].getBoundingClientRect().width;
const cloneCount = 1; // Number of clones to create

// // Duplicate the slides for infinite loop
// for (let i = 0; i < cloneCount; i++) {
//   slides.forEach((slide) => {
//     slideWrap.appendChild(slide.cloneNode(true));
//   });
// }

// Set the wrap width to accommodate clones
// slideWrap.style.width = `${(slideCount + cloneCount) * 100}%`;(it was increasing the size of the images)

let currentIndex = 0;

// Function to update the active slide
const updateSlide = () => {
  const adjustedIndex = currentIndex % slideCount;
  slides.forEach((el, ind) => {
    if (ind === adjustedIndex) {
      el.classList.add("active");
    } else {
      el.classList.remove("active");
    }
  });
};

// Function to handle slide transition
const slideTo = (index) => {
  currentIndex = index;
  const slideValue = currentIndex * slideWidth;
  slideWrap.scrollLeft = slideValue;
  updateSlide();
};

// Function to handle next slide
const nextSlide = () => {
  currentIndex = (currentIndex + 1) % slideCount;
  slideTo(currentIndex);
};

// Function to handle previous slide
const prevSlide = () => {
  currentIndex = (currentIndex - 1 + slideCount) % slideCount;
  slideTo(currentIndex);
};

// Event listeners for next and previous arrows
const arrowNext = document.querySelector(".next-slide");
const arrowPrev = document.querySelector(".prev-slide");
arrowNext.addEventListener("click", nextSlide);
arrowPrev.addEventListener("click", prevSlide);

// Initial setup
updateSlide();
});